<template>
  <div class="container-offline">
    <div class="container-lottie">
      <lottie
        :options="defaultOptions"
        :animCreated=handleAnimation
      />
    </div>
  </div>
</template>

<script>
import Lottie from "vue-lottie";
import animationData from "@/assets/offline.json";

export default {
  name: "Offline",
  components: {
    Lottie
  },
  data() {
    return {
      defaultOptions: {
        animationData: animationData,
      },
      animationSpeed: 1,
    };
  },
  methods: {
    handleAnimation: function (anim) {
      this.anim = anim;
    },

    stop: function () {
      this.anim.stop();
    },

    play: function () {
      this.anim.play();
    },

    pause: function () {
      this.anim.pause();
    },

    onSpeedChange: function () {
      this.anim.setSpeed(this.animationSpeed);
    }
  }
};
</script>
<style scoped>
  .container-offline,
  .container-lottie{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .container-lottie{
    width: 70vw;
    height: 80vh;
  }
</style>